// app/session/session.js

(function () {
    'use strict';
    var controllerId = 'studSession';
    angular.module('app').controller(controllerId, ['common', '$rootScope', '$routeParams', 'datacontext', 'sectionMenu', '$uibModal', '$translate', session]);

    function session(common, $rootScope, $routeParams, datacontext, sectionMenu, $uibModal, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');        
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = $translate.instant('Sessioni');
        vm.view = 'list';       //Opzione list or detail
        vm.icon = '';
        vm.setView = setView;        

        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;

        vm.filter = {};
        vm.filter.ricerca = '';
        vm.fTesto = '';

        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.filter.anno = vm.fAnno;
        
        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.bAddState = false;       
        vm.loading = false;      
        vm.pageSize = 30;
        vm.page = 1;
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        //Elenco per Ordinamento
        vm.list = {};        
        vm.list.ordine = [
            {
                text: 'DataDecrescente', 
                value: 'Data decrescente',
            },
            {
                text: 'Test',
                value: 'Test',
            },
           {
              text: 'Classe',
              value: 'classe',
          }
        ];
        
        vm.ordine = vm.list.ordine[0];        
        vm.selectOrdine = function (item) {            
            vm.ordine = item;   
            cerca();
        };

        vm.getRisultatoSingoloStudente = getRisultatoSingoloStudente;
        vm.answerQuestions = answerQuestions;
                
        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function () {
                    vm.history = $routeParams.history == 'true' ? true : false;
                    if (vm.history == true) {
                        vm.sectionMenu = sectionMenu.setSection('StudSessioniHist');
                        vm.title += ' ' + $translate.instant('Effettuate');
                        vm.icon = 'fa fa-list-alt';
                        vm.list.ordine[0] = {
                            text: 'DataDecrescente',
                            value: 'Data decrescente',
                        };
                        vm.ordine = vm.list.ordine[0];
                    }
                    else {
                        vm.sectionMenu = sectionMenu.setSection('StudSessioniDisp');
                        vm.title += ' ' + $translate.instant('Disponibili');
                        vm.icon = 'fa fa-calendar-o';
                    }
                });
        }


        //****************************************************
        // METODI 
        //****************************************************
        
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;   
            vm.page = 1;
            vm.filter.ricerca = vm.fTesto == null ? '' : vm.fTesto;
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            if (vm.filter.anno != $rootScope.annoScolastico)
                $rootScope.annoScolastico = vm.filter.anno;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            if (vm.history == true) {
                return datacontext.session_countAllHistoryByProc(vm.filter.anno, vm.filter.ricerca)
                    .then(function (data) {
                        if (data) {
                            vm.countRecords = data;
                        }
                    });
            } else {
                return datacontext.session_countAllActiveByProc(vm.filter.anno, vm.filter.ricerca)
                    .then(function (data) {
                        if (data) {
                            vm.countRecords = data;
                        }
                    });
            }
            
        }
                
        function getAllByFilter() {
            if (vm.loading === true) return;
            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;
            
            vm.loading = true;
            if (vm.history == true) {
                return datacontext.session_getAllHistoryByProc(vm.pageSize, vm.page, vm.filter.anno, vm.filter.ricerca, vm.ordine.value)
                    .then(function (data) {
                        if (data.constructor === Array) {
                            vm.page++;
                            data.forEach(function (item) {
                                vm.records.push(item);
                            });
                        }
                        vm.loading = false;
                    });                
            }
            else {
                return datacontext.session_getAllActiveByProc(vm.pageSize, vm.page, vm.filter.anno, vm.filter.ricerca, vm.ordine.value)
                    .then(function (data) {
                        if (data.constructor === Array) {
                            vm.page++;
                            data.forEach(function (item) {
                                vm.records.push(item);
                            });
                        }
                        vm.loading = false;
                    });
            }                        
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRisultatoSingoloStudente(sessionId) {
            var lingua = $translate.proposedLanguage() || $translate.use();
            common.$http.get('/edup/report/GetRisultatoSingoloStudente?lang=' + lingua + '&sessionId=' + sessionId + '&studenteId=' + $rootScope.id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');
                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;

                    var pdfName = "_Risultato_studente.pdf";
                    if (lingua == "en")
                        pdfName = "_Student_result.pdf";

                    if (common.detectIE())
                        window.navigator.msSaveBlob(file, sessionId + pdfName);
                    else
                        a.download = sessionId + pdfName;
                    a.click();
                    // window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                })
                .catch(function (message) {
                    logError($translate.instant('ImpossibileScaricare'));
                });
        }

        //Answer questions
        function answerQuestions(c) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/EDUP_StudSession/modal/answerQuestions.html?version=43',
                controller: 'answerQuestions',
                resolve: {
                    sessione: function () {
                        return c;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem != null)
                    answerQuestions2(returnItem);
            });
        }

        function answerQuestions2(id) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/EDUP_StudSession/modal/answerQuestions2.html?version=43',
                controller: 'answerQuestions2',
                windowClass: 'modal-strict',
                resolve: {
                    studenteSessionId: function () {
                        return id;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                getAllByFilter();
                //if (returnItem == true)
                //    answerQuestions2(c.Id);
            });
        }
    }
})();
